// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1XF_6","notes":"Notes_notes__1MYaw","note":"Notes_note__2rUiJ","markdown":"Notes_markdown__1uXI_"};